import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=919f88da&scoped=true"
import script from "./MessageInput.vue?vue&type=script&lang=js"
export * from "./MessageInput.vue?vue&type=script&lang=js"
import style0 from "./MessageInput.vue?vue&type=style&index=0&id=919f88da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919f88da",
  null
  
)

export default component.exports